import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import {
  createRole,
  deleteRoleById,
  getAllRoles,
  getRoleById,
  updateRoleById,
} from './rolesApi';

export const useCreateRole = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['create_role'],
    mutationFn: createRole,
    onSuccess: () => {
      toast.success('Role created successfully');
      queryClient.invalidateQueries(['roles']);
    },
    onError: (error) => {
      console.log(error.response.data.message);
      toast.error(error.response.data.message);
    },
  });
};

export const useGetAllRoles = () => {
  return useQuery({
    queryKey: ['roles'],
    queryFn: getAllRoles,
    onError: (error) => {
      console.error('Failed to fetch roles: ', error);
      toast.error(
        'Failed to fetch roles: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useGetRoleById = (recordId) => {
  return useQuery({
    queryKey: ['roles', recordId],
    queryFn: () => getRoleById(recordId),
    onError: (error) => {
      console.error('Failed to fetch role:', error);
      toast.error(
        'Failed to fetch role: ' + (error.message || 'Unknown error')
      );
    },
  });
};

export const useUpdateRolebyId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateRoleById,
    mutationKey: ['updateRolebyId'],
    onSuccess: () => {
      toast.success('Successfully updated role');
      queryClient.invalidateQueries(['roles']);
    },
    onError: (err) => {
      console.log(err);
      toast.error('Failed to update role: ' + (err.message || 'Unknown error'));
    },
  });
};

export const useDeleteRolebyId = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteRoleById,
    mutationKey: ['deleteRolebyId'],
    onSuccess: () => {
      toast.success('Successfully deleted role');
      queryClient.invalidateQueries(['roles']);
    },
    onError: (err) => {
      console.log(err);
      toast.error('Failed to delete role: ' + (err.message || 'Unknown error'));
    },
  });
};
